import './App.css'
function View(props){
         const {title,note,setcase}=props;  
         return (
            <div className="view-div">  
             <p className="title">{title}</p>    
             <p className="note">{note}</p>    
             <i className="fa-solid fa-arrow-left backicon" onClick={()=>{setcase('mainpage')}}></i>  
            </div>
         )
         
}
export default View;  